<template>
  <div>
    <div class="form-check m-2">
      <input class="form-check-input" type="checkbox" v-model="showPast" id="showPast">
      <label class="form-check-label" for="showPast">{{ $t('action.showPast') }} <span class="text-nowrap">({{ $t('global.days', 30) }})</span></label>
    </div>
    <table v-if="sortedDeliveries.length > 0" class="table table-hover table-sm table-fit align-middle">
      <thead>
      <tr>
        <th>{{ $t('field.generic.delivery') }}</th>
        <th class="d-none d-sm-table-cell">{{ $t('field.generic.status') }}</th>
        <th>
          {{ $t('field.generic.created') }}
          <font-awesome-icon :icon="['fas', 'sort-up']" />
        </th>
        <th class="d-none d-lg-table-cell">{{ $t('field.generic.linesCount') }}</th>
        <th>{{ $t('field.generic.rowActions') }}</th>
      </tr>
      </thead>
      <tbody>
      <tr v-for="item in sortedDeliveries" :key="item.id">
        <td class="d-table-cell d-sm-none">
          <button class="btn btn-link text-start" type="button" @click="emit('selected', item.id)">
            {{ item.code }}
            <DeliveryStatus :status="item.status"/>
          </button>
        </td>
        <td class="d-none d-sm-table-cell">
          <button class="btn btn-link" type="button" @click="emit('selected', item.id)">
            {{ item.code }}
          </button>
          <span>{{ item.description }}</span>
        </td>
        <td class="d-none d-sm-table-cell"><DeliveryStatus :status="item.status"/></td>
        <AuditCreatedField :audit="item.audit" />
        <td class="d-none d-lg-table-cell">{{ item.lines.length }}</td>
        <td>
          <button v-if="item.status === DELIVERY_HEAD_STATUS.inProgress" class="btn btn-outline-danger" type="button" @click="removeDelivery(item.id)">
            <font-awesome-icon :icon="['fas', 'trash']" />
          </button>
        </td>
      </tr>
      </tbody>
    </table>
    <span v-else>{{ $t('error.noData') }}</span>
  </div>

</template>

<script setup lang="ts">
import { computed, onMounted, ref, watch } from 'vue';
import { storeToRefs } from 'pinia';
import { useSessionStore, useDeliveriesStore } from '@/stores';
import { toast } from 'vue3-toastify';
import { AuditCreatedField } from "@/components/fields";
import DeliveryStatus from './DeliveryStatus.vue';
import { DELIVERY_HEAD_STATUS } from '@/models/Enums';

const showPast = ref(false);

const sessionStore = useSessionStore();
const { selectedSiteId } = storeToRefs(sessionStore);

const deliveriesStore = useDeliveriesStore();
const { data: deliveries } = storeToRefs(deliveriesStore);

const emit = defineEmits<{
  (e: 'selected', id: number): void
}>();

watch(showPast, async (newvalue) => {
  await deliveriesStore.fetchAll(newvalue);
});

const sortedDeliveries = computed(() => {
  return [...deliveries.value].sort((a, b) => {
    return a.audit.createdAt < b.audit.createdAt ? -1 : 1;
  });
});

const removeDelivery = async (id: number) => {
  await deliveriesStore.cancel(id);
};

onMounted(async () => {
  await deliveriesStore.fetchAll();
  if (selectedSiteId.value === 0) {
    toast.error('No site selected', { autoClose: 10000 });
  }
});
</script>
